<template>
  <div>
    <el-dialog
      title="查看培训资料"
      :visible.sync="dialogVisible"
      width="800px"
      @close="handleClose"
    >
      <div v-if="materialsData" class="materials-view">
        <div class="materials-header">
          <h3>{{ materialsData.title }}</h3>
          <div class="materials-meta">
            <el-tag size="small">{{ trainingCategoryText(materialsData.category) || "未分类" }}</el-tag>
            <span v-if="materialsData.estimatedDuration" class="duration">
              {{ materialsData.estimatedDuration }}分钟
            </span>
            <span class="duration">
              过期天数：{{
                materialsData.expireDays != null && materialsData.expireDays >= 0
                  ? materialsData.expireDays + "天"
                  : "不限"
              }}
            </span>
          </div>
        </div>

        <div class="materials-content">
          <div class="description">
            <h4>资料描述</h4>
            <p>{{ materialsData.description }}</p>
          </div>

          <div v-if="materialsData.files && materialsData.files.length > 0" class="files-section">
            <h4>资料文件</h4>
            <div class="file-list">
              <div v-for="(file, index) in materialsData.files" :key="index" class="file-item">
                <div class="file-info">
                  <span class="file-name">{{ file.title }}</span>

                  <i :class="getFileIcon(file.fileType)" class="file-icon"></i>
                  <el-tag size="mini" style="margin-left: 8px">
                    {{ file.fileType | materialTypeText }}
                  </el-tag>
                  <span class="file-size">共{{ file.files.length }}个文件</span>
                  <span class="file-size">
                    {{ formatFileSize(file.totalSize) }}
                  </span>
                </div>
                <div class="file-actions">
                  <el-button size="mini" @click="handlePreviewFile(file)">预览</el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 文件预览对话框 -->
    <el-dialog
      :title="previewTitle"
      :visible.sync="previewDialogVisible"
      width="900px"
      append-to-body
      @close="handlePreviewClose"
    >
      <div v-if="previewFiles && previewFiles.length > 0" class="preview-files">
        <div v-for="(item, index) in previewFiles" :key="index" class="preview-file-item">
          <div class="file-header">
            <span class="file-name">{{ item.name }}</span>
            <div class="file-header-right">
              <span class="file-size">{{ formatFileSize(item.size) }}</span>
              <el-button
                size="mini"
                type="primary"
                icon="el-icon-download"
                @click="handleDownloadSingleFile(item)"
                style="margin-left: 12px"
              >
                下载
              </el-button>
            </div>
          </div>
          <div class="file-preview-wrapper">
            <file-preview :value="item.url" />
          </div>
        </div>
      </div>
      <div v-else class="empty-tip">
        <el-empty description="暂无文件" :image-size="80"></el-empty>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="previewDialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import trainingCategoryMixin from "../utils/trainingCategory";
export default {
  name: "MaterialsViewDialog",
  mixins: [trainingCategoryMixin],
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    materialsData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogVisible: false,
      // 预览相关
      previewDialogVisible: false,
      previewFiles: [],
      previewTitle: "文件预览"
    };
  },
  watch: {
    visible: {
      handler(val) {
        this.dialogVisible = val;
      },
      immediate: true
    }
  },
  methods: {
    // 获取资料类型标签样式
    getMaterialTypeTag(type) {
      const typeMap = {
        VIDEO: "primary",
        PDF: "success",
        IMAGE: "warning"
      };
      return typeMap[type] || "info";
    },

    // 获取文件图标
    getFileIcon(type) {
      const iconMap = {
        VIDEO: "el-icon-video-camera",
        PDF: "el-icon-document",
        IMAGE: "el-icon-picture"
      };
      return iconMap[type] || "el-icon-document";
    },

    // 格式化文件大小
    formatFileSize(size) {
      if (size < 1024) {
        return size + " B";
      } else if (size < 1024 * 1024) {
        return (size / 1024).toFixed(1) + " KB";
      } else {
        return (size / (1024 * 1024)).toFixed(1) + " MB";
      }
    },

    // 预览文件
    handlePreviewFile(file) {
      if (!file.files || file.files.length === 0) {
        this.$message.warning("该文件组暂无文件");
        return;
      }
      this.previewTitle = `预览 - ${file.title}`;
      this.previewFiles = file.files.map((item) => ({
        name: item.name,
        size: item.size,
        url: item.url
      }));
      this.previewDialogVisible = true;
    },

    // 下载单个文件（在预览窗口中）
    handleDownloadSingleFile(file) {
      if (!file || !file.url) {
        this.$message.error("文件地址不存在");
        return;
      }
      try {
        const link = document.createElement("a");
        link.href = file.url;
        link.download = file.name || "download";
        link.target = "_blank";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.$message.success("文件下载已开始");
      } catch (error) {
        console.error("下载文件失败:", error);
        // 如果直接下载失败，尝试在新窗口打开
        window.open(file.url, "_blank");
      }
    },

    // 关闭预览对话框
    handlePreviewClose() {
      this.previewFiles = [];
      this.previewTitle = "文件预览";
    },

    // 关闭
    handleClose() {
      this.dialogVisible = false;
      this.$emit("update:visible", false);
    }
  }
};
</script>

<style lang="less" scoped>
.materials-view {
  .materials-header {
    margin-bottom: 20px;
    padding-bottom: 16px;
    border-bottom: 1px solid #e4e7ed;

    h3 {
      margin: 0 0 12px 0;
      color: #303133;
      font-size: 20px;
    }

    .materials-meta {
      display: flex;
      align-items: center;

      .duration {
        margin-left: 16px;
        color: #909399;
        font-size: 14px;
      }
    }
  }

  .materials-content {
    .description {
      margin-bottom: 24px;

      h4 {
        margin: 0 0 8px 0;
        color: #303133;
        font-size: 16px;
      }

      p {
        margin: 0;
        color: #606266;
        line-height: 1.6;
      }
    }

    .files-section {
      h4 {
        margin: 0 0 16px 0;
        color: #303133;
        font-size: 16px;
      }

      .file-list {
        .file-item {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 12px;
          border: 1px solid #e4e7ed;
          border-radius: 4px;
          margin-bottom: 8px;

          .file-info {
            display: flex;
            align-items: center;
            flex: 1;

            .file-icon {
              margin-right: 8px;
              font-size: 16px;
              color: #409eff;
            }

            .file-name {
              font-weight: 500;
              margin-right: 8px;
            }

            .file-size {
              margin-left: 8px;
              color: #909399;
              font-size: 12px;
            }
          }

          .file-actions {
            .el-button {
              margin-left: 8px;
            }
          }
        }
      }
    }
  }
}

.dialog-footer {
  text-align: right;
}

.preview-files {
  max-height: 600px;
  overflow-y: auto;

  .preview-file-item {
    margin-bottom: 24px;
    padding-bottom: 24px;
    border-bottom: 1px solid #e4e7ed;

    &:last-child {
      margin-bottom: 0;
      padding-bottom: 0;
      border-bottom: none;
    }

    .file-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 12px;

      .file-name {
        font-weight: 500;
        color: #303133;
        font-size: 14px;
      }

      .file-header-right {
        display: flex;
        align-items: center;

        .file-size {
          color: #909399;
          font-size: 12px;
        }
      }
    }

    .file-preview-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 200px;
      padding: 16px;
      background: #f5f7fa;
      border-radius: 4px;
    }
  }
}

.empty-tip {
  text-align: center;
  padding: 40px 0;
}
</style>
